/* eslint-disable no-undef, react/prop-types */
import React from 'react';
import { css } from 'react-emotion';
import Img from 'gatsby-image';
import { Box, Flex } from '../components/Layout';
import colors from '../utils/colors';
import media from '../utils/media';

const style = css`
  text-align: center;
  & ul {
    list-style-type: none;
    color: ${colors.primary};
  }
  h1,
  h2 {
    padding-bottom: 0.5em;
  }
`;

const tanssijatStyle = css`
  text-align: center;
  & ul {
    margin-top: 1em;
    list-style-type: none;
    color: ${colors.primary};
  }
`;

const flexStyle = css`
  margin-bottom: 3em;
  flex-wrap: wrap;
  justify-content: space-around;
`;

const tanssijaStyle = css`
  margin-top: 2em;
  padding-left: 0.5em;
  padding-right: 0.5em;
`;

const imgStyle = css`
  border-radius: 5px;
  margin-bottom: 1em;
`;

const outerImgWrapper = css`
  width: 8em;
  margin-left: auto;
  margin-right: auto;
`;

const imgRyhmaStyle = css`
  width: 100%;
  margin-top: 1em;
  margin-bottom: 1em;
`;

const outerImgRyhmaWrapper = css`
  margin-left: auto;
  margin-right: auto;
`;

const lastStyle = css`
  text-align: center;
  padding-bottom: 10%;
  p {
    margin-top: 2em;
  }
`;

const tanssijatList = css`
  text-align: center;
  padding-top: 2em;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-around;
  & ul {
    list-style-type: none;
    color: ${colors.primary};
  }
  ${media.mid`
    flex-direction: row;
  `};
`;

const Esiintyjat = ({ data }) => {
  const { hygieia, apteekkari, ryhma, tytti, maija, franz } = data;
  return (
    <Box>
      <Box
        className={style}
        width={[1, 1, 1 / 2]}
        m={['3.5rem 0 0 0', '3.5rem 0 0 0', '3.5rem auto 0 auto']}
        px={[3, 3, 0]}
        color={colors.secondary}
      >
        <h1>Rooleissa</h1>

        <Flex className={flexStyle}>
          <div className={tanssijaStyle}>
            <Img
              className={imgStyle}
              outerWrapperClassName={outerImgWrapper}
              alt="Owla ja kadonnut walkia, Tytti, Kuvaaja: Mikko Leinonen"
              sizes={tytti.childImageSharp.sizes}
            />
            <p>
              <strong>Tytti</strong>
            </p>
            <p>Ella Rautamies</p>
          </div>
          <div className={tanssijaStyle}>
            <Img
              className={imgStyle}
              outerWrapperClassName={outerImgWrapper}
              alt="Owla ja kadonnut walkia, Franz, Kuvaaja: Mikko Leinonen"
              sizes={franz.childImageSharp.sizes}
            />
            <p>
              <strong>Franz</strong>
            </p>
            <p>Jyrki Kontkanen</p>
          </div>
          <div className={tanssijaStyle}>
            <Img
              className={imgStyle}
              outerWrapperClassName={outerImgWrapper}
              alt="Owla ja kadonnut walkia, Maija, Kuvaaja: Mikko Leinonen"
              sizes={maija.childImageSharp.sizes}
            />
            <p>
              <strong>Maija</strong>
            </p>
            <p>Anna Myllylä</p>
          </div>
        </Flex>

        <Flex className={flexStyle}>
          <div className={tanssijaStyle}>
            <Img
              className={imgStyle}
              outerWrapperClassName={outerImgWrapper}
              alt="Owla ja kadonnut walkia, Apteekkari, Kuvaaja: Inkeri Jäntti"
              sizes={apteekkari.childImageSharp.sizes}
            />
            <p>
              <strong>Apteekkari</strong>
            </p>
            <p>Elssa Antikainen</p>
          </div>
          <div className={tanssijaStyle}>
            <Img
              className={imgStyle}
              outerWrapperClassName={outerImgWrapper}
              alt="Owla ja kadonnut walkia, Hygieia, Kuvaaja: Inkeri Jäntti"
              sizes={hygieia.childImageSharp.sizes}
            />
            <p>
              <strong>Hygieia</strong>
            </p>
            <p>Anni Koponen</p>
          </div>
        </Flex>
        <br />
        <div>
          <p>
            <strong>Toripolliisi</strong>
          </p>
          <p>Kari Sirniö</p>
        </div>
        <br />
        <div>
          <p>
            <strong>Hon</strong>
          </p>
          <p>Aarni Korja / Vili Kolanen</p>
        </div>
        <br />
        <div>
          <p>
            <strong>Han</strong>
          </p>
          <p>Iina Kolanen / Lotta Luosujärvi</p>
        </div>
        <br />
        <div>
          <p>
            <strong>Hen</strong>
          </p>
          <p>Maija Anttonen / Heta Honkalampi</p>
        </div>
        <br />

        <h2>Bändi</h2>
        <p>Erja Mesimäki</p>
        <p>Lauri Marjakangas</p>
        <br />
        <div className={tanssijatStyle}>
          <h2>Tanssijat</h2>

          <p>
            Yli 90 hengen työryhmä on koottu Oulunsuun nuorisoseuran, Oulunsalon
            nuorisoseuran ja nuorisoseura Vilikkaan kansantanssinharrastajista
            sekä Oulun ammattikorkeakoulun tanssinopettajaopiskelijoista.
            <br />
            Iältään esiintyjät ovat 7–77-vuotiaita.
          </p>
        </div>
      </Box>
      <div className={lastStyle}>
        <Img
          className={imgRyhmaStyle}
          outerWrapperClassName={outerImgRyhmaWrapper}
          alt="Owla ja kadonnut walkia, Owla Työryhmä, Kuvaaja: Mikko Leinonen"
          sizes={ryhma.childImageSharp.sizes}
        />
        <h2>Jokkainen on laisesa!</h2>
        <div className={tanssijatList}>
          <ul>
            <li>Arkkukangas Marika</li>
            <li>Haapala Meri</li>
            <li>Heikkinen Teemu</li>
            <li>Heinonen Elena</li>
            <li>Heinonen Aino</li>
            <li>Iljana Anni</li>
            <li>Isoahde Oona</li>
            <li>Jolula Kati</li>
            <li>Jussila Kirsi</li>
            <li>Juvani Raija</li>
            <li>Jylhä Eetu</li>
            <li>Jylhä Helka</li>
            <li>Kaikkonen Oona</li>
            <li>Kaikkonen Anu</li>
            <li>Kakko Saila</li>
            <li>Kallen-Autio Heli</li>
            <li>Kallen-Autio Matti</li>
            <li>Kangas Noora</li>
            <li>Kauppi Hilla</li>
            <li>Kauppi Elina</li>
            <li>Kauppi Ari</li>
            <li>Kemppainen Eeva</li>
            <li>Kirppu Anni</li>
            <li>Kohtala Antti</li>
            <li>Koskela Tarja</li>
            <li>Koukkari Reijo</li>
            <li>Krankkala Nea</li>
          </ul>
          <ul>
            <li>Kunnas Miikku</li>
            <li>Laitinen Emma</li>
            <li>Laukka Jouko</li>
            <li>Lepola Pirkka</li>
            <li>Lukkari Riikka</li>
            <li>Luomajoki Juuso</li>
            <li>Lyly-Yrjänäinen Maija</li>
            <li>Lyttinen Amanda</li>
            <li>Määttä Leena</li>
            <li>Määttä Kalevi</li>
            <li>Malinen Inka</li>
            <li>Malinen Joona</li>
            <li>Malinen Pinja</li>
            <li>Manninen Peppiina</li>
            <li>Mantila Aino</li>
            <li>Martikainen Eino</li>
            <li>Myllylä Hannu</li>
            <li>Myllylä Maija</li>
            <li>Niva Terhi</li>
            <li>Ollanketo Saana</li>
            <li>Ollanketo Sinna</li>
            <li>Päätalo Marianne</li>
            <li>Pakkanen Päivi</li>
            <li>Perälä Anna-Emilia</li>
            <li>Perälä Veetu</li>
          </ul>
          <ul>
            <li>Perälä Ella</li>
            <li>Perälä Henna</li>
            <li>Pietikäinen Kaarina</li>
            <li>Raetsaari Helka</li>
            <li>Raipoaho Raimo</li>
            <li>Rankinen Sini-Pilvi</li>
            <li>Rantapää Eila</li>
            <li>Rantapää Matti</li>
            <li>Rasila Seija</li>
            <li>Romppainen Roope</li>
            <li>Ronkainen Aino</li>
            <li>Sääskilahti Santeri</li>
            <li>Salmi Anna</li>
            <li>Salonen Timo</li>
            <li>Savuoja Sini</li>
            <li>Savuoja Niko</li>
            <li>Seppälä Marja–Liisa</li>
            <li>Seppänen Laura</li>
            <li>Sirniö Ailakki</li>
            <li>Suoniemi Siiri</li>
            <li>Suronen Minna</li>
            <li>Tarumaa Riikka</li>
            <li>Tervaskanto Eero</li>
            <li>Tikka Jarkko</li>
            <li>Timonen Sofia</li>
            <li>Valkama Anita</li>
            <li>Veijalainen Susanna</li>
          </ul>
        </div>
        <p>
          <small>
            Kuvat:<br />
            Tytti, Franz, Maija, Ryhmäkuva: Mikko Leinonen<br />
            Apteekkari, Hygieia: Inkeri Jäntti
          </small>
        </p>
      </div>
    </Box>
  );
};

export const query = graphql`
  query EsiintyjatQuery {
    hygieia: file(relativePath: { eq: "hygieia.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 512) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
    apteekkari: file(relativePath: { eq: "apteekkari.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 512) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
    ryhma: file(relativePath: { eq: "tyoryhma_logo.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 3690) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
    tytti: file(relativePath: { eq: "tytti.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 512) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
    maija: file(relativePath: { eq: "maija.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 512) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
    franz: file(relativePath: { eq: "franz.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 3690) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
  }
`;

export default Esiintyjat;



// WEBPACK FOOTER //
// ./src/pages/esiintyjat.js